import { useNavigate } from "react-router-dom";

const cities = [
  {
    name: "İstanbul",
    slug: "istanbul",
    region: "Marmara",
    restaurants: 1240,
    places: 890,
    image: "https://readdy.ai/api/search-image?query=Istanbul%20Turkey%20Bosphorus%20bridge%20city%20skyline%20golden%20hour%20warm%20tones%20mosques%20minarets%20beautiful%20panoramic%20view%20vibrant%20colors&width=600&height=700&seq=city-istanbul&orientation=portrait",
    highlight: "Boğaz manzarası ve tarihi yarımada",
    featured: true,
  },
  {
    name: "Gaziantep",
    slug: "gaziantep",
    region: "Güneydoğu Anadolu",
    restaurants: 380,
    places: 210,
    image: "https://readdy.ai/api/search-image?query=Gaziantep%20Turkey%20old%20city%20bazaar%20copper%20market%20traditional%20architecture%20warm%20stone%20buildings%20spice%20market&width=600&height=700&seq=city-gaziantep&orientation=portrait",
    highlight: "Türkiye'nin gastronomi başkenti",
    featured: true,
  },
  {
    name: "İzmir",
    slug: "izmir",
    region: "Ege",
    restaurants: 620,
    places: 430,
    image: "https://readdy.ai/api/search-image?query=Izmir%20Turkey%20Kordon%20seafront%20promenade%20Aegean%20sea%20sunset%20colorful%20buildings%20waterfront%20Mediterranean%20atmosphere&width=600&height=700&seq=city-izmir&orientation=portrait",
    highlight: "Ege'nin incisi, deniz ve lezzet",
    featured: false,
  },
  {
    name: "Mardin",
    slug: "mardin",
    region: "Güneydoğu Anadolu",
    restaurants: 145,
    places: 180,
    image: "https://readdy.ai/api/search-image?query=Mardin%20Turkey%20ancient%20stone%20city%20hillside%20Mesopotamia%20plains%20golden%20sunset%20traditional%20architecture%20historic%20buildings&width=600&height=700&seq=city-mardin&orientation=portrait",
    highlight: "Taş evler ve Mezopotamya manzarası",
    featured: false,
  },
  {
    name: "Trabzon",
    slug: "trabzon",
    region: "Karadeniz",
    restaurants: 210,
    places: 160,
    image: "https://readdy.ai/api/search-image?query=Trabzon%20Turkey%20Black%20Sea%20coast%20green%20mountains%20lush%20nature%20Sumela%20monastery%20misty%20landscape%20dramatic%20scenery&width=600&height=700&seq=city-trabzon&orientation=portrait",
    highlight: "Karadeniz'in yeşil cenneti",
    featured: false,
  },
  {
    name: "Antalya",
    slug: "antalya",
    region: "Akdeniz",
    restaurants: 780,
    places: 560,
    image: "https://readdy.ai/api/search-image?query=Antalya%20Turkey%20old%20harbor%20Kaleici%20ancient%20city%20turquoise%20Mediterranean%20sea%20cliffs%20yachts%20warm%20sunny%20day&width=600&height=700&seq=city-antalya&orientation=portrait",
    highlight: "Antik liman ve turkuaz kıyılar",
    featured: false,
  },
];

const FeaturedCities = () => {
  const navigate = useNavigate();

  const handleCityClick = (slug: string) => {
    navigate(`/restoranlar?city=${slug}`);
  };

  const [mainCity, secondCity, ...restCities] = cities;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-amber-500 text-sm font-semibold uppercase tracking-widest">Şehir Rehberi</span>
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mt-2" style={{ fontFamily: "'Playfair Display', serif" }}>
              Öne Çıkan<br />Şehirler
            </h2>
          </div>
          <button
            onClick={() => navigate("/restoranlar")}
            className="hidden md:flex items-center gap-2 text-sm font-medium text-amber-600 hover:text-amber-700 cursor-pointer whitespace-nowrap"
          >
            Tüm Şehirler
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </button>
        </div>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          {/* Main featured city - large */}
          <div
            onClick={() => handleCityClick(mainCity.slug)}
            className="lg:col-span-5 relative rounded-2xl overflow-hidden cursor-pointer group h-[480px]"
          >
            <img
              src={mainCity.image}
              alt={mainCity.name}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
            <div className="absolute top-4 left-4">
              <span className="bg-amber-500 text-white text-xs px-2.5 py-1 rounded-full font-semibold">
                Editör Seçimi
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <p className="text-amber-300 text-xs font-semibold uppercase tracking-wider mb-1">{mainCity.region}</p>
              <h3 className="text-3xl font-bold text-white mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                {mainCity.name}
              </h3>
              <p className="text-stone-300 text-sm mb-4">{mainCity.highlight}</p>
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-1.5">
                  <div className="w-5 h-5 flex items-center justify-center bg-white/20 rounded-full">
                    <i className="ri-restaurant-line text-white text-xs"></i>
                  </div>
                  <span className="text-white text-sm font-semibold">{mainCity.restaurants.toLocaleString()}</span>
                  <span className="text-stone-400 text-xs">restoran</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <div className="w-5 h-5 flex items-center justify-center bg-white/20 rounded-full">
                    <i className="ri-map-pin-line text-white text-xs"></i>
                  </div>
                  <span className="text-white text-sm font-semibold">{mainCity.places.toLocaleString()}</span>
                  <span className="text-stone-400 text-xs">mekan</span>
                </div>
              </div>
            </div>
          </div>

          {/* Second featured city - medium */}
          <div
            onClick={() => handleCityClick(secondCity.slug)}
            className="lg:col-span-4 relative rounded-2xl overflow-hidden cursor-pointer group h-[480px]"
          >
            <img
              src={secondCity.image}
              alt={secondCity.name}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
            <div className="absolute top-4 left-4">
              <span className="bg-rose-500 text-white text-xs px-2.5 py-1 rounded-full font-semibold">
                Gastronomi
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <p className="text-amber-300 text-xs font-semibold uppercase tracking-wider mb-1">{secondCity.region}</p>
              <h3 className="text-2xl font-bold text-white mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                {secondCity.name}
              </h3>
              <p className="text-stone-300 text-xs mb-3">{secondCity.highlight}</p>
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-1">
                  <i className="ri-restaurant-line text-amber-400 text-xs"></i>
                  <span className="text-white text-xs font-semibold">{secondCity.restaurants}</span>
                  <span className="text-stone-400 text-xs">restoran</span>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-map-pin-line text-amber-400 text-xs"></i>
                  <span className="text-white text-xs font-semibold">{secondCity.places}</span>
                  <span className="text-stone-400 text-xs">mekan</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right column - 4 small cities */}
          <div className="lg:col-span-3 flex flex-col gap-4 h-[480px]">
            {restCities.slice(0, 4).map((city) => (
              <div
                key={city.slug}
                onClick={() => handleCityClick(city.slug)}
                className="relative flex-1 rounded-xl overflow-hidden cursor-pointer group"
              >
                <img
                  src={city.image}
                  alt={city.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/20"></div>
                <div className="absolute inset-0 flex items-center px-4">
                  <div className="flex-1 min-w-0">
                    <p className="text-amber-300 text-xs font-medium">{city.region}</p>
                    <h4 className="text-white font-bold text-base leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                      {city.name}
                    </h4>
                  </div>
                  <div className="flex flex-col items-end gap-1 flex-shrink-0 ml-2">
                    <div className="flex items-center gap-1">
                      <i className="ri-restaurant-line text-white/70 text-xs"></i>
                      <span className="text-white text-xs font-semibold">{city.restaurants}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <i className="ri-map-pin-line text-white/70 text-xs"></i>
                      <span className="text-white text-xs font-semibold">{city.places}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile: show all as horizontal scroll */}
        <div className="mt-4 flex gap-3 overflow-x-auto pb-2 lg:hidden">
          {restCities.map((city) => (
            <div
              key={city.slug}
              onClick={() => handleCityClick(city.slug)}
              className="relative flex-shrink-0 w-40 h-48 rounded-xl overflow-hidden cursor-pointer group"
            >
              <img
                src={city.image}
                alt={city.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <h4 className="text-white font-bold text-sm" style={{ fontFamily: "'Playfair Display', serif" }}>{city.name}</h4>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-stone-300 text-xs">{city.restaurants} rest.</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCities;
